/**
 * Phase 133 — StreamX Polish Sweep
 * Shimmer skeleton primitives matching the StreamX dark aesthetic.
 * Avoids jarring "white shimmer on dark" mismatch — uses the same #07111F /
 * #22314F palette + an orange-tinted moving gradient.
 */
import '@/styles/livex.css';

export function LivexShimmerBlock({ className = '', style = {} }) {
  return (
    <div
      aria-hidden
      className={`livex-shimmer rounded ${className}`}
      style={style}
    />
  );
}

/** Stream card skeleton — matches LivexLive grid cards. */
export function LivexShimmerStreamCard({ testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-[#07111F] border-2 border-[#22314F] rounded-xl overflow-hidden"
    >
      <div className="aspect-video bg-[#0c1a2e] relative">
        <div className="livex-shimmer absolute inset-0 opacity-50" />
      </div>
      <div className="p-4 space-y-2">
        <LivexShimmerBlock className="h-4 w-3/4" />
        <div className="flex items-center justify-between">
          <LivexShimmerBlock className="h-3 w-1/3" />
          <LivexShimmerBlock className="h-3 w-12" />
        </div>
      </div>
    </div>
  );
}

/** Generic row skeleton — academy/invoice list. */
export function LivexShimmerRow({ testid }) {
  return (
    <div
      data-testid={testid}
      className="p-4 sm:p-5 bg-[#07111F] border-2 border-[#22314F] rounded-xl"
    >
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-[#0c1a2e] livex-shimmer" />
        <div className="flex-1 space-y-2">
          <LivexShimmerBlock className="h-4 w-2/5" />
          <LivexShimmerBlock className="h-3 w-3/5" />
        </div>
        <LivexShimmerBlock className="h-8 w-24 rounded-lg" />
      </div>
    </div>
  );
}

/** KPI tile skeleton — overview grids. */
export function LivexShimmerKpi({ testid }) {
  return (
    <div data-testid={testid} className="p-5 bg-[#07111F] border-2 border-[#22314F] rounded-xl">
      <LivexShimmerBlock className="h-4 w-4 mb-2" />
      <LivexShimmerBlock className="h-7 w-16 mb-2" />
      <LivexShimmerBlock className="h-3 w-20" />
    </div>
  );
}
